<template>
  <div class="second_row" style="min-height: 90px">
    <div class="filters_container">
      <div v-if="!multipleSelection" class="search_container">
        <label for="search">Filter</label>
        <div class="input_search">
          <IconFilter class="icon is-small" />
          <input
            ref="searchServiceInput"
            type="text"
            class="input"
            placeholder="by name, location or level..."
            name="search"
            @input="filterServices"
          />
        </div>
      </div>
      <b-field
        v-if="!multipleSelection"
        label="Sort by Level"
        class="header_select"
      >
        <b-select
          placeholder="Select a service level"
          @input="searchServicesByServiceType($event)"
        >
          <option
            v-for="serviceLevel in serviceLevelOptions"
            :key="serviceLevel.level"
            :value="serviceLevel.level"
          >
            {{ serviceLevel.label }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="is-flex is-align-items-center">
      <b-switch
        v-if="!hideElementByCondition"
        v-model="multipleSelection"
        class="is-small color-2 mr-4"
        @input="showMultipleSelection"
      >
        <p class="color-7">Multiple selection</p>
      </b-switch>
      <b-switch
        v-if="hasViewSalePricePermission"
        v-model="unitPricesView"
        class="is-small color-2 mr-4"
        @input="showUnitPrices"
      >
        <p class="color-7">Unit Prices</p>
      </b-switch>
      <b-switch v-model="localSummaryView" class="is-small color-2 mr-0">
        <p class="color-7">Summary View</p>
      </b-switch>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SERVICE_LEVELS } from "@/constants/services";
import { helper } from "@/utils/itinerary";
import { serviceHelper } from "@/utils/service";
import { PERMISSION, SERVICE_TABLE_FIELDS_IDS } from "@/constants";

export default {
  name: "ServiceTableFilters",
  props: {
    fields: {
      type: Array,
      required: true,
    },
    showMultipleSelection: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      unitPricesView: false,
      multipleSelection: false,
      helper: { ...helper },
    };
  },
  computed: {
    ...mapGetters({
      initialItineraryServices: "itinerary/getInitialServicesItinerary",
      itinerary: "itinerary/getItinerary",
      authData: "auth/getAuthData",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      pricesLevels: "itinerary/getPricesLevels",
      showSummaryView: "utils/showSummaryView",
    }),
    serviceLevelOptions() {
      return [{ level: 0, label: "--" }, ...this.pricesLevels];
    },
    hasViewSalePricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_SALE_PRICE]
      );
    },
    localSummaryView: {
      get() {
        return this.showSummaryView;
      },
      set(value) {
        this.$store.commit("utils/SET_SHOW_SUMMARY_VIEW", value);
      },
    },
  },
  watch: {
    localSummaryView: {
      immediate: true,
      handler(value) {
        this.showSummary(value);
      },
    },
    fields(newValues) {
      this.multipleSelection = newValues.some((newValue) => {
        return (
          newValue.key === "selected" &&
          !newValue.class.includes("hidden_field")
        );
      });
    },
  },
  methods: {
    showSummary(evt) {
      const summaryFields = [
        SERVICE_TABLE_FIELDS_IDS.VISIBLE,
        SERVICE_TABLE_FIELDS_IDS.DESTINATION,
        SERVICE_TABLE_FIELDS_IDS.LEVEL,
        SERVICE_TABLE_FIELDS_IDS.PAX,
        this.unitPricesView
          ? SERVICE_TABLE_FIELDS_IDS.PRICE_UNIT
          : SERVICE_TABLE_FIELDS_IDS.PRICE,
        SERVICE_TABLE_FIELDS_IDS.PERCENTAGE_MARGIN,
        SERVICE_TABLE_FIELDS_IDS.COST_CUR,
      ];

      const newFields = this.fields.map((field) => {
        if (!summaryFields.includes(field.key)) return field;

        return {
          ...field,
          class: evt
            ? field.class.replace("shown_field", "") + " hidden_field "
            : field.class
                .replace("hidden_field", "")
                .replace("cellHidden", "") + " shown_field ",
        };
      });
      this.$emit("updateFields", newFields);
    },
    showUnitPrices(evt) {
      if (evt && this.localSummaryView) return;

      const unitPriceClass = evt
        ? "priceUnitField shown_field"
        : "priceUnitField hidden_field";
      const priceClass = evt
        ? "priceField hidden_field"
        : "priceField shown_field";
      const newFields = this.fields.map((field) => {
        if (field.key !== "price_unit" && field.key !== "price") return field;
        return {
          ...field,
          class: field.key === "price" ? priceClass : unitPriceClass,
        };
      });
      this.$emit("updateFields", newFields);
    },
    searchServicesByServiceType(idServiceType = 0) {
      if (idServiceType === 0)
        this.$emit(
          "updateFilteredItineraryServices",
          this.initialItineraryServices
        );
      else {
        const newServices = this.initialItineraryServices.filter(
          (service) =>
            service.level === idServiceType ||
            service.level === SERVICE_LEVELS.ALL.id
        );
        this.$emit("updateFilteredItineraryServices", newServices);
      }
    },
    filterServices(event) {
      const search = event.target.value.trim();
      const newServices = this.initialItineraryServices?.filter((service) => {
        const codeWithName = this.helper.getServiceSearchString(service);
        return codeWithName.toLowerCase().includes(search.toLowerCase());
      });
      this.$emit("updateFilteredItineraryServices", newServices);
    },
  },
};
</script>
<style>
.tableServiceTable {
  position: relative;
}
.tableServiceTable .second_row {
  margin: -1rem 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.second_row .input_search {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #f00b81;
}

.second_row .input_search .input {
  outline: none;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  width: 18rem;
  background-color: transparent;
}

.second_row .input_search svg {
  color: #f00b81;
  width: 1.2rem;
  height: 1.2rem;
  margin-left: 0.5rem;
}
.filters_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 1rem;
}
.filters_container .header_select {
  margin: 1.5rem 0 1rem;
}
.filters_container :is(label) {
  text-align: left;
  margin-left: 0.25rem;
  font-size: 0.65rem;
  font-weight: 600;
}
.filters_container .header_select :is(.select, select) {
  font-size: 0.8rem;
  width: 100%;
  border-radius: 0.5rem;
  background-color: transparent;
}
.filters_container .header_select :is(select:focus) {
  border-color: #f00b81;
  box-shadow: 0 0 0 0.125em #f00b8138;
}
.filters_container .header_select .select::after {
  border-color: #f00b81;
}
@media screen and (max-width: 480px) {
  .tableServiceTable .second_row {
    margin: 1rem 0;
    flex-direction: column;
    align-items: flex-start;
    display: none;
  }
  .filters_container {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .filters_container .search_container {
    width: 100%;
  }
  .tableServiceTable .second_row .filters_container .header_select {
    margin: 1rem 0;
  }
  .second_row .input_search .input {
    width: 100%;
  }
}
</style>
